import React from "react";

const RaindropCopyable = ({
  text,
  displayText = null,
  isCopyable = true,
  children,
}) => {
  if (displayText === null) {
    displayText = text;
  }

  const [copied, setCopied] = React.useState(false);

  let textClass = "";
  let iconClass =
    "far fa-copy text-color-dark-text-secondary text-sm group-hover:scale-95  transition-all";
  if (copied) {
    textClass = "text-color-status-good";
    iconClass = "fas fa-check text-color-status-good text-sm";
  }

  const onClick = () => {
    setCopied(true);
    navigator.clipboard.writeText(text);

    // Start a timer to reset the icon after 2 seconds
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  if (isCopyable === false) {
    return children;
  }

  return (
    <div
      className="flex flex-row items-center gap-2 cursor-pointer group  "
      onClick={onClick}
    >
      {children && children}
      {children === undefined && <div className={textClass}>{displayText}</div>}
      <i className={iconClass}></i>
    </div>
  );
};

export default RaindropCopyable;
